/**
 * Fallback guest-app content.
 *
 * This is the *demo / offline* data that ships in the bundle so the app is
 * fully navigable without a backend. In production each tenant's events,
 * places, host info etc. come from the core-api (tenant-scoped). States read
 * from here today; swapping in `await this.app.api.get(...)` later is a
 * drop-in replacement — the view templates don't change.
 *
 * Photos are intentionally tokenised gradients (the `photo` key maps to a
 * `.ga-photo--<key>` class) rather than shipped binaries: real imagery is
 * tenant content, and the gradient placeholders re-tint automatically under a
 * white-label theme.
 */

export const EVENTS = [
    { id: "wine",    title: "Weinabend am Marktplatz",       cat: "Genuss",  scope: "region", day: "14", mon: "Jun", time: "18:30", loc: "Marktplatz Wehlen",   dist: "1,2 km",      photo: "wine",   icon: "wine",
      desc: "Regionale Winzer schenken aus, dazu Livemusik und Spezialitäten aus der Sächsischen Schweiz." },
    { id: "castle",  title: "Führung Festung Königstein",    cat: "Kultur",  scope: "region", day: "15", mon: "Jun", time: "10:00", loc: "Festung Königstein",  dist: "8 km",        photo: "culture", icon: "landmark",
      desc: "Eine geführte Tour über eine der größten Bergfestungen Europas mit weitem Blick über das Elbtal." },
    { id: "hike",    title: "Geführte Wanderung zur Bastei", cat: "Natur",   scope: "own",    day: "15", mon: "Jun", time: "09:30", loc: "Treffpunkt Rezeption", dist: "Start am Haus", photo: "valley", icon: "mountain",
      desc: "Unsere hauseigene Morgenwanderung zu den berühmten Felsnadeln — mit Frühstückspaket zum Mitnehmen." },
    { id: "boat",    title: "Dampferfahrt auf der Elbe",     cat: "Ausflug", scope: "region", day: "16", mon: "Jun", time: "14:00", loc: "Anleger Rathen",      dist: "3 km",        photo: "coast",  icon: "ship",
      desc: "Gemütliche Fahrt mit dem historischen Raddampfer durch das Elbsandsteingebirge." },
    { id: "concert", title: "Konzert in der Felsenbühne",    cat: "Musik",   scope: "region", day: "17", mon: "Jun", time: "20:00", loc: "Felsenbühne Rathen",  dist: "3,5 km",      photo: "dusk",   icon: "music",
      desc: "Open-Air-Konzert in einer der schönsten Naturbühnen Europas — ein Abend unter freiem Himmel." },
    { id: "family",  title: "Familien-Grillabend im Garten", cat: "Familie", scope: "own",    day: "18", mon: "Jun", time: "17:30", loc: "Hotelgarten",         dist: "Start am Haus", photo: "ember", icon: "flame",
      desc: "Unser wöchentlicher Grillabend für große und kleine Gäste — mit Lagerfeuer und Stockbrot." }
];

export const PLACES = [
    { id: "bastei",      cat: "Natur",  title: "Bastei-Aussicht", meta: "2,4 km · Wanderung",  photo: "valley", icon: "mountain",
      duration: "45 Min", level: "Mittel", rating: "4,9", address: "Basteistraße, 01847 Lohmen",
      desc: "Die Basteibrücke ist das Wahrzeichen der Sächsischen Schweiz. Von der Aussichtsplattform öffnet sich ein weiter Blick über das Elbtal und die markanten Felsnadeln — besonders schön im Morgenlicht." },
    { id: "felsenkeller", cat: "Genuss", title: "Felsenkeller", meta: "650 m · Restaurant", photo: "coast", icon: "utensils",
      duration: "Restaurant", level: "Regional", rating: "4,7", address: "Marktplatz 3, Stadt Wehlen",
      desc: "Bodenständige sächsische Küche mit saisonalen Zutaten aus der Region — ein Geheimtipp direkt am Marktplatz, nur wenige Schritte vom Haus." },
    { id: "altstadt",    cat: "Kultur", title: "Altstadt Wehlen", meta: "5 km · Spaziergang", photo: "culture", icon: "landmark",
      duration: "Spaziergang", level: "Leicht", rating: "4,6", address: "Markt, 01829 Stadt Wehlen",
      desc: "Verwinkelte Gassen, historische Fachwerkhäuser und ein verträumter Marktplatz direkt an der Elbe — ideal für einen entspannten Nachmittag." }
];

export function getEvent( id )
{
    return EVENTS.find( ( e ) => e.id === id ) || null;
}

export function getPlace( id )
{
    return PLACES.find( ( p ) => p.id === id ) || null;
}
